<lex-sidenav-container>
  <ng-container left>
    <div></div>
    <!--Case Search-->
    <div class="case-search" style="margin-top: 8px; font-size: 15px; height: 75px; align-items: center">
      <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; place-content: stretch space-between; align-items: stretch; gap: 20px;">
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row">
          <div mat-line style="width: 100%; display: flex;">
            <mat-form-field class="show-no-errors custom-infix-padding" style="margin-left: 15px; margin-right: 15px; padding-top: 8px; width:100%">
              <input matInput placeholder="Search Cases" #searchBox id="search-box" (keyup)="updateSearchText(searchBox.value)" [(ngModel)]="searchText" />
              <button id="clearSearch" *ngIf="searchBox.value" matSuffix mat-icon-button aria-label="Clear" (click)="searchBox.value=''; updateSearchText(searchBox.value)">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div mat-line style="width: 40%; display: flex; font-size:12px; padding-top: 8px">
            <mat-form-field class="density-neg-1 show-no-errors" style="margin-right: 15px;">
              <mat-label>Order By</mat-label>
              <mat-select [(ngModel)]="selectedOrderBy" (selectionChange)="updateOrderBy()">
                <mat-option *ngFor="let value of orderByValues" [value]="value.orderBy">
                  <div>{{value.displayName}}</div>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      </div>

    <cdk-virtual-scroll-viewport #leftScroll itemSize="48" style="height:87%">
      <mat-action-list style="overflow: hidden;" *ngIf="cases$ | async as cases">
        <!--Case List-->
        <button mat-list-item [attr.id]="'selectCaseId.'+lexbeCase.caseId" *cdkVirtualFor="let lexbeCase of cases" [ngClass]="{'sidenav-selected-item': selectedCase === lexbeCase, 'sidenav-row-item': selectedCase !== lexbeCase}" (click)="selectCase(lexbeCase)">
          <span  matListItemIcon style="color: #FFC107; margin-inline-end: 12px; margin-top:20px;" *ngIf="lexbeCase.caseDocCount !== lexbeCase.indexDocCount" matTooltip="Warning: Doc Count Mismatch">
            <mat-icon>warning</mat-icon>
          </span>
          <div matListItemTitle>
            {{lexbeCase.caseName}}
          </div>
          <div matListItemLine style="color:grey; font-size:13px"> {{lexbeCase.account.accountName}} </div>
          <mat-divider></mat-divider>
        </button>

      </mat-action-list>
    </cdk-virtual-scroll-viewport>

    <div></div>
  </ng-container>

  <!--Case Main Layout main content-->
  <ng-container right>
    <div style="flex-direction: column; box-sizing: border-box; display: flex; place-content: stretch space-between; align-items: stretch; flex: 1 1 0%; gap: 20px;" *ngIf="!selectedCase">
      <div></div>
      <div style="flex-direction: row; box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px;">
        <div></div>
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column" *ngIf="cases$ | async as cases">
          <mat-toolbar color="primary" class="toolbar-over-card">
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
              <mat-card-title>Total Cases: {{cases.length}}</mat-card-title>
            </div>
          </mat-toolbar>
          <div style="flex: 1 1 0%; box-sizing: border-box;">
            <mat-card appearance="outlined">
              <div style="font-size: 15px">
                No Case Selected
              </div>
            </mat-card>
          </div>
        </div>
        <div></div>
      </div>
      <div></div>
    </div>
    <lex-case-edit *ngIf="selectedCase" style="flex: 1 1 0%; box-sizing: border-box;" [selectedCaseId]="selectedCase.caseId" [searchTerm]="searchText"  [selectedOrderBy]="selectedOrderBy"></lex-case-edit>
  </ng-container>
</lex-sidenav-container>
